/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const Committee = {

	deleteCommittee (context, committeeId, onSuccess, onError, options) {
		Api.delete(context,
			"/committee/committee"
			+ "?committeeId=" + committeeId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	get (context, committeeId, onSuccess, onError, options) {
		Api.get(context,
			"/committee"
			+ "?committeeId=" + committeeId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getAllCommittees (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/committee/all-committees"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getCommitteeNameId (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/committee/committee-name-id"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getContestCommitteesWithOffers (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/committee/contest-committees-with-offers"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getLeadingCommittees (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/committee/leading-committees"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getLeadingCommitteesName (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/committee/leading-committees-name"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getManagementAccessStatus (context, committeeId, onSuccess, onError, options) {
		Api.get(context,
			"/committee/management-access-status"
			+ "?committeeId=" + committeeId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postAutoAssignOffers (context, contestId, onSuccess, onError, options) {
		Api.post(context,
			"/committee/auto-assign-offers"
			+ "?contestId=" + contestId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postCommittee (context, contestId, name, onSuccess, onError, options) {
		Api.post(context,
			"/committee/committee"
			+ "?contestId=" + contestId
			+ "&name=" + name
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postEvaluation (context, committeeId, onSuccess, onError, options) {
		Api.post(context,
			"/committee/evaluation"
			+ "?committeeId=" + committeeId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putAssignOffer (context, offerId, committeeId, onSuccess, onError, options) {
		Api.put(context,
			"/committee/assign-offer"
			+ "?offerId=" + offerId
			+ "&committeeId=" + committeeId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putCommittee (context, committeeId, newName, countryIds, onSuccess, onError, options) {
		Api.put(context,
			"/committee/committee"
			+ "?committeeId=" + committeeId
			+ "&newName=" + newName
			+ "&countryIds=" + countryIds
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putEvaluation (context, committeeId, onSuccess, onError, options) {
		Api.put(context,
			"/committee/evaluation"
			+ "?committeeId=" + committeeId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putUndoFinishEvaluation (context, committeeId, onSuccess, onError, options) {
		Api.put(context,
			"/committee/undo-finish-evaluation"
			+ "?committeeId=" + committeeId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
